var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.117,
    height: 81.124,
    viewBox: "0 0 88.117 81.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7124",
    "data-name": "Group 7124",
    transform: "translate(-453 -2608.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7129",
    "data-name": "Path 7129",
    d: "M19708.836-1373.8l-54.709-80.719s-8.863-2.5-10,4.932S19708.836-1373.8,19708.836-1373.8Z",
    transform: "translate(-19167.719 4062.947)",
    fill: "#eba533",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7128",
    "data-name": "Path 7128",
    d: "M19661.629-1432.975l-14.8-21.838s-2.4-.677-2.707,1.334S19661.629-1432.975,19661.629-1432.975Z",
    transform: "translate(-19191.117 4062.947)",
    fill: "#213bc8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.42de2b3417c73c549a153e4b97d8347a.svg";
export { ForwardRef as ReactComponent };